import { createReduxSlice } from '../../ReduxSlice'
import { State } from 'app/types/redux-types'
import { OpportunityCustomer } from 'app/types/types'
import { PayloadAction } from '@reduxjs/toolkit'

const initialState: State<OpportunityCustomer> = {
  data: {} as OpportunityCustomer,
  status: 'idle',
  error: null
}

const currentAccountSlice = createReduxSlice({
  name: 'currentAccount',
  initialState,
  reducers: {
    setCurrentAccount: (state, action: PayloadAction<OpportunityCustomer>) => {
      state.data = action.payload
    },
    resetCustomerData: state => {
      state.data = {} as OpportunityCustomer
      state.status = 'idle'
      state.error = null
    }
  }
})
export const { setCurrentAccount, resetCustomerData } = currentAccountSlice.actions

export default currentAccountSlice.reducer
